<app-pageheader [Parent]="this">
  @if (ModelIsNew==false) {
    <app-form-delete-button [Parent]="this" [Form]="Form" [Model]="Model"
      DeleteUrl="enforcement/voidreasons/" DeleteNavLink="/enforcement/voidreasons" [DeleteCheck]="false">
    </app-form-delete-button>
  }
  <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()">
  </app-form-save-button>
</app-pageheader>

<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">Void Reason</p>
          <div class="panel-block is-block">
            <app-field Label="Text">
              <div class="control">
                <input formControlName="Text" class="input" type="text" placeholder="Enter void reason text" />
                <app-validator [For]="Form.get('Text')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Description">
              <div class="control">
                <textarea formControlName="Description" class="textarea" placeholder="Optional description"></textarea>
              </div>
            </app-field>
          </div>
        </article>
      </div>
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">Attributes</p>
          <div class="panel-block is-block">
            <div class="field">
              <label class="checkbox">
                <input type="checkbox" formControlName="CountsAgainstPerformance" />
                <strong>Counts Against Officer Performance</strong>
              </label>
              <p class="help">When enabled, voids using this reason will negatively impact the issuing officer's performance metrics.</p>
            </div>
            <div class="field mt-4">
              <label class="checkbox">
                <input type="checkbox" formControlName="PubliclyVisible" />
                <strong>Publicly Visible</strong>
              </label>
              <p class="help">When enabled, this reason will be shown to the public when viewing a voided citation.</p>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
}

